export default class scrollToViewHelper {
  constructor() {
    this.scrollToViewLinks = document.querySelectorAll('[data-scroll-target]');

    if(this.scrollToViewLinks[0] !== null) {
      this.init();
    }
  }

  init() {
    this.scrollToViewLinks.forEach(link => {
      link.addEventListener('click', (e) => {
        console.log(link.dataset.scrollTarget);
        const scrollTarget = document.querySelector(link.dataset.scrollTarget);
        if(scrollTarget !== null) {
          scrollTarget.scrollIntoView();
        }
      });
    });
  }
}